import React from 'react';
import { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { AppBar, Tabs, Tab } from '@material-ui/core';

const styles = theme => ({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    background: {
        backgroundColor: theme.palette.background.default,
    },
    appBar: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.secondary.main,
        display: 'flex',
        flexDirection: 'row',
    },
    appBarSecondary: {
        backgroundColor: '#F5F5F5',
    },
    tabRootSecondary: {
        '&:hover': {
            backgroundColor: '#E8E8E8',
        },
    },
    tabSelectedSecondary: {
        backgroundColor: '#E8E8E8',
    },
    content: {
        flex: '1 1 auto',
    },
    headerContent: {
        alignSelf: 'center',
        marginLeft: 'auto',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    tab: {
        fontSize: '13px !important',
        maxWidth: '160px',
        minWidth: 'min-content',
        flex: '1',
        display: 'inline-flex',
        width: 'auto',
        flexShrink: 'initial',
    },
    tabWide: {
        maxWidth: 'max-content',
    },
    tabs: {
        width: '100%',
        display: 'flex',
        flex: 1,
    },
    tabsContainer: {
        width: '100%',
    },
    tabLabel: {
        lineHeight: '1.3em',
    },
    tabHidden: {
        display: 'none',
    },
    scroller: {
        overflowX: 'auto !important',
        '&::-webkit-scrollbar': {
            width: 8,
            height: 8,
        },

        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0, 0, 0, 0.26)',

            '&:hover': {
                backgroundColor: '#01579b',
            },
        },
    },
});

const PageTabs = props => {
    const {
        classes,
        tabs,
        darkBackground = [],
        children,
        current,
        onChange,
        headerContent,
        hidden = [],
        secondary,
    } = props;
    const [tab, setTab] = useState(0);
    const num = onChange ? current : tab;
    return (
        <div
            className={classNames({
                [classes.root]: true,
                [classes.background]: darkBackground.includes(num),
            })}
        >
            <AppBar
                position="static"
                classes={{
                    root: classNames({
                        [classes.appBar]: true,
                        [classes.appBarSecondary]: secondary,
                    }),
                }}
            >
                <Tabs
                    classes={{
                        scroller: classes.scroller,
                        root: classes.tabs,
                        flexContainer: classes.tabsContainer,
                    }}
                    value={num}
                    onChange={(event, tab) =>
                        onChange ? onChange(tab) : setTab(tab)
                    }
                    textColor="secondary"
                >
                    {prepareTabs(tabs, hidden).map((tab, index) => (
                        <Tab
                            classes={{
                                root: classNames({
                                    [classes.tab]: true,
                                    [classes.tabWide]: tab.label.length >= 14,
                                    [classes.tabHidden]: tab.hidden,
                                    [classes.tabRootSecondary]: secondary,
                                }),
                                wrapper: classes.tabLabel,
                                selected: classNames({
                                    [classes.tabSelectedSecondary]: secondary,
                                }),
                            }}
                            key={index}
                            label={tab.label}
                            value={tab.name}
                            disabled={tab.disabled}
                        />
                    ))}
                </Tabs>
                {headerContent && (
                    <div className={classes.headerContent}>{headerContent}</div>
                )}
            </AppBar>
            <div className={classes.content}>{children(num)}</div>
        </div>
    );
};

function prepareTabs(tabs, hidden) {
    return tabs.map(tab => {
        if (typeof tab === 'string') {
            return {
                label: tab,
                value: tab,
                hidden: hidden.find(item => item === tab),
            };
        }
        return tab;
    });
}

export default withStyles(styles)(PageTabs);
